import { axiosClient } from '@/libs/axios-client';

// Monthly reminder of unapproved incoming e-invoices (server: components/einvoice-reminders).
const BASE = '/einvoice-reminders';

export const getEinvoiceReminderSettings = async () => {
  const { data } = await axiosClient.get(`${BASE}/settings`);
  return data.data;
};

export const saveEinvoiceReminderSettings = async (payload) => {
  const { data } = await axiosClient.put(`${BASE}/settings`, payload);
  return data.data;
};

export const getEinvoiceReminderCandidates = async () => {
  const { data } = await axiosClient.get(`${BASE}/candidates`);
  return data.data;
};

export const getEinvoiceReminderPreview = async (date) => {
  const { data } = await axiosClient.get(`${BASE}/preview`, { params: date ? { date } : {} });
  return data.data;
};

export const getEinvoiceReminderPreviewHtml = async (companyId, date) => {
  const { data } = await axiosClient.get(`${BASE}/preview/${companyId}/html`, { params: date ? { date } : {} });
  return data.data;
};

export const getEinvoiceSummaryPreview = async (date) => {
  const { data } = await axiosClient.get(`${BASE}/summary/preview`, { params: date ? { date } : {} });
  return data.data;
};

export const getEinvoiceReminderCompany = async (companyId) => {
  const { data } = await axiosClient.get(`${BASE}/companies/${companyId}`);
  return data.data;
};

export const saveEinvoiceReminderCompany = async (companyId, payload) => {
  const { data } = await axiosClient.put(`${BASE}/companies/${companyId}`, payload);
  return data.data;
};
